// The one look for every "Add …" action (#478): bold, in the brand orange, with
// its icon (a + unless said otherwise), and at least 44 px high for the iPad.
// Not used for the photo tiles (Take / Upload photo open the camera or a file
// picker) or the take-off's icon-only "+" for another paint system, which sits
// in a narrow table cell where a label would widen the surface column.
import type { ReactNode } from 'react';
import { Plus, type LucideIcon } from 'lucide-react';

const ADD_ACTION = 'inline-flex min-h-11 items-center gap-1 text-sm font-semibold text-primary';

interface Look {
  children: ReactNode;
  icon?: LucideIcon;
}

/** An add action's words and icon, for one that isn't a button (a label beside a list to pick from). */
export function AddActionLabel({ children, icon: Icon = Plus }: Look) {
  return (
    <span className={ADD_ACTION}>
      <Icon className="h-4 w-4 shrink-0" /> {children}
    </span>
  );
}

/** An "Add …" button. */
export function AddAction({ children, icon: Icon = Plus, onClick, disabled, className = '' }: Look & { onClick: () => void; disabled?: boolean; className?: string }) {
  return (
    <button type="button" onClick={onClick} disabled={disabled} className={`${ADD_ACTION} hover:underline disabled:opacity-40 ${className}`}>
      <Icon className="h-4 w-4 shrink-0" /> {children}
    </button>
  );
}
